module.exports = __webpack_public_path__ + "static/media/IMG-6.f8b58860.jpg";